import { render, staticRenderFns } from "./NavTile.vue?vue&type=template&id=55a72a4e&"
import script from "./NavTile.vue?vue&type=script&lang=js&"
export * from "./NavTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NavTile.vue"
export default component.exports